import { ReactElement } from 'react';
import { ProjectStatsSectionsContainer } from '../../../../modules/projects/details/stats/ProjectStatsSections.container';

export const ProjectDetailsStatisticsView = (): ReactElement => <ProjectStatsSectionsContainer />;
